import Modal from 'utils/packages/Modal';
import { getReduxStore } from 'store/storeRegistry';
import { AccountTypeDisplayLong } from '../constants';
import { selectTradingAccountFromId } from '../reducers/selectors';
export const AVAILABLE_TITLE = 'Available';
// Also shown in the hover tooltip that replaces this modal on web
export const getAvailableExplanation = (accountType) => `These are the funds available right now in the ${AccountTypeDisplayLong[accountType || 'GIA']}. It may be lower than your total balance if you have money pending from recent transfers or investments.`;
const AvailableModal = {
    show: (tradingAccountId) => {
        const tradingAccount = selectTradingAccountFromId(getReduxStore().getState(), tradingAccountId);
        Modal.showConfirmation({
            title: AVAILABLE_TITLE,
            subtitle: getAvailableExplanation(tradingAccount?.accountType),
            confirmButtonTitle: 'Okay',
        });
    },
};
export default AvailableModal;
